import './signature-module-screen.scss'

import { defineComponent } from 'vue';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';

import { CLOSE_SIGNATURE_MODULE_TOPIC, SAVE_CURRENT_REPORT_TOPIC } from '../../../../busTopics';
import { SignerInputCard } from '../signer-input-card';

export const SignatureModuleScreen = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sSignerInputCard: SignerInputCard
    },
    props: ['signers'],
    template: require('./signature-module-screen.html'),
    data() {
        return {
            backIcon: faArrowLeft,
        }
    },
    methods: {
        closeSignatureModule() {
            this.emitOnBus(CLOSE_SIGNATURE_MODULE_TOPIC)
        },
    },
})
